module.exports = __webpack_public_path__ + "mo/img/ic_close.54ac77c2.svg";